import { InjectionToken } from '@angular/core';

export const ALLOW_REGISTRATION = new InjectionToken<boolean>('Allow registration flag');
